import { render, staticRenderFns } from "./EnglishAddress.vue?vue&type=template&id=facb893c&scoped=true&"
import script from "./EnglishAddress.vue?vue&type=script&lang=js&"
export * from "./EnglishAddress.vue?vue&type=script&lang=js&"
import style0 from "./EnglishAddress.vue?vue&type=style&index=0&id=facb893c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facb893c",
  null
  
)

export default component.exports